import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import {
  DashboardSlotCapacityState,
  DashboardDropdownState,
  SlotDetail,
} from "./types/dashboardSlotCapacityModal";

export const initialState: DashboardSlotCapacityState = {
  slotDetail: {
    id: 0,
    pickers: {
      disconnected: [],
      withoutTransaction: [],
      withTransaction: [],
    },
    region: null,
    workZone: null,
    startAt: null,
    finishAt: null,
  },
  dropdownState: "withTrx",
  loading: false,
  showModal: false,
};

const SLICE_NAME = "dashboardSlotCapacity";

export const dashboardSlotCapacitySlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setDropdownState: (
      state,
      action: PayloadAction<DashboardDropdownState>
    ) => {
      state.dropdownState = action.payload;
    },
    getSlotDetailRequest: (state, action: PayloadAction<number>) => {},
    getSlotDetailError: (state) => {},
    getSlotDetailSuccess: (state, action: PayloadAction<SlotDetail>) => {
      state.slotDetail = action.payload;
      state.showModal = true;
    },
    toggleCapacityDetailModalVisibility: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.showModal = action.payload;
    },
  },
});

export const dashboardSlotCapacitySelector = (state: RootState) =>
  state.dashboardSlotCapacity;

export const actions = dashboardSlotCapacitySlice.actions;

export default dashboardSlotCapacitySlice.reducer;
